<template>
  <div id="search" class="mainBlock">
    <div style="width: 100%;height: 100%;background-color: #FAFAFA;margin-top: 64px">
      <headerSearch></headerSearch>
      <div style="display: flex;align-items: center;height: 30vh;overflow: hidden;width: 1600px;margin: auto">
        <imgScorll v-if="showImg" :linkList="linkList" :imgList="bannerList"></imgScorll>
      </div>
      <div style="width: 1300px;margin: auto">
        <div style="position: relative;top: -15vh;padding: 40px;min-height: 30vh;background-color: #fff;border-radius: 10px;box-shadow: 0 0 20px rgba(51, 51, 51, 0.25);">
          <div style="padding: 10px 0">
            <div class="newSearchTitle"><span></span><span>请输入材质名称查找</span></div>
            <div class="m_t_10">
              <input @keydown.enter="searchWareHouse" v-model="name" style="border: 1px solid #eee;width: 120px;padding: 10px 20px" class="allInput dis_line v_m" placeholder="请输入材质名查找" type="text">
              <button @click="searchWareHouse" class="redButton m_l_10">搜索</button>
            </div>
          </div>
          <div style="text-align: right" v-show="showDetail">
            <div style="width: 100%;height: 600px" id="container"></div>
            <button @click="showDetail = false" style="margin-top: 20px" class="cancelButton">返回</button>
          </div>
          <div v-if="goodList.length > 0 && !showDetail" class="resultList" style="margin-bottom: 40px;margin-top: 40px">
            <table>
              <thead>
              <tr>
                <th>材质名称</th>
                <th>密度</th>
                <th>说明</th>
              </tr>
              </thead>
              <tbody>
              <tr :key="index" v-for="(item, index) in goodList">
                <td>{{item.name}}</td>
                <td>{{item.density}} g/cm³</td>
                <td>{{item.remark}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let marker
let map
export default {
  name: 'search',
  data () { // 所有的数据都写在里面
    return {
      showDetail: false,
      showImg: false,
      name: '',
      goodList: [],
      linkList: [],
      bannerList: [
        require('../../../assets/img/backgroundImg.png')
      ]
    }
  },
  created () {
    document.title = '百钢一下 | 钢铁电商，百炼成钢'
  },
  destroyed () {
  },
  mounted () {
    this.getBannerList()
  },
  methods: {
    getBannerList () {
      this.$axiox.get('/baigang/app/home/queryBannerList/' + 1).then(p => {
        this.bannerList = []
        this.linkList = []
        for (let i = 0; i < p.data.length; i++) {
          if (!(i === 2 || i === 3)) {
            this.bannerList.push(p.data[i].imgUrl)
            this.linkList.push(p.data[i].title)
          }
        }
        this.showImg = true
      })
    },
    showDetailFun (item) {
      this.showDetail = true
      this.$nextTick(p => {
        // eslint-disable-next-line no-undef
        map = new AMap.Map('container', {
          resizeEnable: true,
          center: [parseFloat(item.longitude), parseFloat(item.latitude)],
          zoom: 13
        })
        clearMarker()
        addMarker(parseFloat(item.longitude), parseFloat(item.latitude), item.name)
      })
    },
    searchWareHouse () {
      if (this.name) {
        this.$axiox.post('/baigang/app/good/queryMaterialQualityList', {name: this.name, currPage: 1, pageSize: 99}).then(p => {
          this.goodList = p.data.list
          this.showDetail = false
        })
      }
    }
  }
}
// 实例化点标记
function addMarker (x, y, name) {
  // eslint-disable-next-line no-undef
  marker = new AMap.Marker({
    icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
    position: [x, y],
    // eslint-disable-next-line no-undef
    offset: new AMap.Pixel(-13, -30)
  })
  var markerContent = document.createElement('div')

  // 点标记中的图标
  var markerImg = document.createElement('img')
  markerImg.className = 'markerlnglat'
  markerImg.src = '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png'
  markerContent.appendChild(markerImg)

  // 点标记中的文本
  var markerSpan = document.createElement('span')
  markerSpan.className = 'marker'
  markerSpan.innerHTML = name
  markerContent.appendChild(markerSpan)
  marker.setContent(markerContent)
  marker.setMap(map)
}
// function updateIcon() {
//
//   marker.setIcon('//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png')
// }

// function updateContent() {
//
//   if (!marker) {
//     return;
//   }
//
//   // 自定义点标记内容
//   var markerContent = document.createElement("div");
//
//   // 点标记中的图标
//   var markerImg = document.createElement("img");
//   markerImg.className = "markerlnglat";
//   markerImg.src = "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png";
//   markerContent.appendChild(markerImg);
//
//   // 点标记中的文本
//   var markerSpan = document.createElement("span");
//   markerSpan.className = 'marker';
//   markerSpan.innerHTML = "Hi，我被更新啦！";
//   markerContent.appendChild(markerSpan);
//
//   marker.setContent(markerContent); //更新点标记内容
//   marker.setPosition([116.391467, 39.927761]); //更新点标记位置
// }

// 清除 marker
function clearMarker () {
  if (marker) {
    marker.setMap(null)
    marker = null
  }
}
</script>
<style scoped>
  .searchBlock{
    width: 600px;
    height: 40px;
    border: 1px solid #D71E1E;
    border-radius: 4px;
  }
  .searchBlock input{
    flex: 1;
    height: 100%;
    border: none;
    border-radius: 4px 0px 0px 4px;
    padding: 0 10px;
  }
  .searchBlock div{
    padding-left: 10px;
    padding-right: 9px;
    height: 100%;
    background: #D71E1E;
    color: #fff;
    font-weight: bold;
    text-align: center;
    line-height: 40px;
  }
  .yellowBtn{
    height: 37px;
    background: #D71E1E;
    font-size: 17px;
    font-weight: 600;
    color: #FFFFFF;
    width: 202px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 18px;
  }
  .yellowBtn img{
    margin-right: 18px;
  }
  .typeBlock{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 15px;
  }
  .typeBlock div{
    padding: 5px 12px;
    border-radius: 2px;
    border: 1px solid #DDDDDD;
    margin: 0 22px 14px 0;
    cursor: pointer;
  }
  .typeBlock div.selected{
    border: 1px solid #D71E1E;
    color: #D71E1E;
  }
  .filterBlock{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-size: 12px;
    background-color: #F2F2F2;
    height: 40px;
    border: 1px solid #DDDDDD;
    margin-bottom: 10px;
  }
  .filterBlock .selected{
    margin-left: 30px;
    padding-right: 17px;
  }
  .filterBlock .selected .seltedItem{
    margin-left: 12px;
  }
  .filterBlock .selected .seltedItem div{
    position: relative;
    color: #D71E1E;
    padding: 5px 12px 5px 6px;
    border: 1px solid #D71E1E;
    margin-right: 15px;
    /*flex-wrap: wrap;*/
  }
  .filterBlock .selected .seltedItem div img{
    position: absolute;
    right: -7px;
    top: 7px;
  }
  .filterBlock .norm{
    margin-left: 30px;
    height: 30px;
    line-height: 30px;
  }
  .filterBlock .norm .inputBlock{
    background-color: #fff;
    border: 1px solid #DDDDDD;
  }
  .filterBlock .norm .inputBlock span{
    padding: 0 6px;
    border-right: 1px solid #DDDDDD;
  }
  .filterBlock .norm .inputBlock input{
    height: 30px;
    font-size: 12px;
    padding: 0 6px 0 16px;
    border: none;
  }
  .filterBlock .norm .normBtn{
    height: 30px;
    padding: 0 14px;
  }
  .orderBlock{
    height: 54px;
    justify-content: space-around;
    background: #FAFAFA;
    border-radius: 4px 4px 0px 0px;
    border-bottom: 1px solid #E8E8E8;
    margin-bottom: 15px;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/page/aboutUs.vue